export default "__VITE_ASSET__1b07a2eb__"